import { render, staticRenderFns } from "./MySelectThree.vue?vue&type=template&id=8145eb12&scoped=true"
import script from "./MySelectThree.vue?vue&type=script&lang=js"
export * from "./MySelectThree.vue?vue&type=script&lang=js"
import style0 from "./MySelectThree.vue?vue&type=style&index=0&id=8145eb12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8145eb12",
  null
  
)

export default component.exports